import * as SliderPrimitive from '@radix-ui/react-slider';
import classNames from 'classnames';
import React from 'react';
import styles from './Slider.module.scss';

interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Slider> {
  /** Width of the disabled range in px (start of slider/min value) */
  disabledWidth?: number;
  /** So we can affect styles on action state (e.g, pan/zoom) */
  isActive?: boolean;
}
const Slider = React.forwardRef<HTMLButtonElement, SliderProps>((props, forwardedRef) => {
  const { disabledWidth = 0, isActive = false, className, ...rest } = props;
  return (
    <SliderPrimitive.Root
      className={classNames(styles.SliderRoot, className)}
      defaultValue={[50]}
      max={100}
      min={0}
      step={1}
      {...rest}
      ref={forwardedRef}
    >
      <SliderPrimitive.Track className={styles.SliderTrack}>
        <SliderPrimitive.Range className={styles.SliderRange} />
        <SliderPrimitive.Range
          className={styles.SliderRangeDisabled}
          style={{ width: disabledWidth }}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={classNames(styles.SliderThumb, {
          [styles.active]: isActive,
        })}
        aria-label="Slider"
      />
    </SliderPrimitive.Root>
  );
});

export { Slider };
export type { SliderProps };
